export default {
    /**
     * API getters
     */
    getApi(store) {
        const loc = window.location.host;
        const hn = loc.split('.')[0];
        if (hn === 'localhost:8080') return 'http://localhost:3030';
        const testStr = hn.split('-');
        if (testStr[0] && testStr[1] && testStr[1] === 'test') return 'https://admin-test-api.gegservices.io';
        if (hn !== 'admin-dev' && hn !== 'admin-test') return 'https://admin-api.gegservices.io';
        const url = `https://${hn}-api.gegservices.io`;
        return store.mainApi || url;
        // return 'http://localhost:3031';
    },
    getToken(store) {
        return store.token;
    },

    /**
    * Routes
    */
    getRoute(store) {
        return store.route;
    },

    /**
    * Authentication
    */
    isAuthenticated: store => !!store.token,
    authStatus: store => store.status,
    getDomain(store) {
        return store.domain;
    },
    getTenant(store) {
        return store.tenant;
    },
    getUser(store) {
        return store.user;
    },
    /**
    * Charts
    */
    getCharts(store) {
        return store.charts;
    },

    /**
    * Media
    */
    getMedia(store) {
        return store.media;
    },
    checkMediaLoaded(store) {
        return store.mediaLoaded;
    },
    getActiveMedia(store) {
        return store.activeMedia;
    },

    getSelectedMedia(store) {
        return store.selectedMedia;
    },

    getAllMediaLibraries(store) {
        return store.allMediaLibraries;
    },

    getActiveMediaLibrary(store) {
        return store.activeMediaLibrary;
    },

    getMediaTabs(store) {
        return store.mediaTabs
    },
    getActiveMediaTab(store) {
        return store.activeMediaTab
    },

    /**
    * Modals
    */
    getShowAddCardToSequenceModal(store) {
        return store.showAddCardToSequenceModal;
    },

    getShowAddMediaToCardModal(store) {
        return store.showAddMediaToCardModal;
    },

    getShowAddSequenceToPolicyModal(store) {
        return store.showAddSequenceToPolicyModal;
    },

    getShowUploadMediaModal(store) {
        return store.showUploadMediaModal;
    },

    getShowUpdateThumbModal(store) {
        return store.showUpdateThumbModal;
    },

    getShowDeprecateMediaModal(store) {
        return store.showDeprecateMediaModal;
    },

    getShowColdDeckModal(store) {
        return store.showColdDeckModal;
    },

    getShowLogoutModal(store) {
        return store.showLogoutModal;
    },

    getShowCardHelpModal(store) {
        return store.showCardHelpModal;
    },

    getShowCreateCardModal(store) {
        return store.showCreateCardModal;
    },

    getShowCreateLocalRecord(store) {
        return store.showCreateLocalRecordModal;
    },

    getShowCreateMediaLibrary(store) {
        return store.showCreateMediaLibraryModal;
    },

    getShowCreateMediaLibraryLocalRecord(store) {
        return store.showCreateMediaLibraryLocalRecordModal;
    },

    getShowCreateProductLocalRecord(store) {
        return store.showCreateProductLocalRecordModal;
    },

    getShowCreateProductGroupLocalRecord(store) {
        return store.showCreateProductGroupLocalRecordModal;
    },

    getShowCreateMarket(store) {
        return store.showCreateMarketModal;
    },

    getShowCreateProduct(store) {
        return store.showCreateProductModal;
    },

    getShowCreateProductGroup(store) {
        return store.showCreateProductGroupModal;
    },

    getShowDeleteRecord(store) {
        return store.showDeleteRecordModal;
    },

    getShowUploadProductImage(store) {
        return store.showUploadProductImageModal;
    },
    getShowCardIcon(store) {
        return store.showCardIconModal;
    },

    getShowCopyVolumeLinks(store) {
        return store.showCopyVolumeLinksModal;
    },

    getShowCopyLocalRecord(store) {
        return store.showCopyLocalRecordModal;
    },

    getShowDeleteProductModal(store) {
        return store.showDeleteProductModal;
    },

    getShowRestoreProductModal(store) {
        return store.showRestoreProductModal;
    },


    /**
    * Products
    */

    getProducts(store) {
        return store.products;
    },

    getActiveProduct(store) {
        return store.activeProduct;
    },

    getActiveProductGroup(store) {
        return store.activeProductGroup;
    },

    getAllProductGroups(store) {
        return store.allProductGroups;
    },

    getIsEditingPrimaryImage(store) {
        return store.isEditingPrimaryImage;
    },

    /**
    * Markets
    */
    getMarkets(store) {
        return store.markets;
    },
    getActiveMarket(store) {
        return store.activeMarket;
    },
    checkMarketsLoaded(store) {
        return store.marketsLoaded;
    },

    /**
    * Cards
    */
    getCards(store) {
        return store.cards;
    },
    getActiveCard(store) {
        return store.activeCard;
    },
    checkCardsReady(store) {
        return store.cardsLoaded;
    },

    getCardTypes(store) {
        return store.cardTypes
    },

    getActiveLocale(store) {
        return store.activeLocale;
    },

    getActiveLocalRecord(store) {
        return store.activeLocalRecord;
    },

    getActiveLocalRecordSaved(store) {
        return store.activeLocalRecordSaved;
    },

    getCardIconContext(store) {
        return store.cardIconContext;
    },

    /**
    * Policies
    */

    getPolicies(store) {
        return store.policies;
    },

    getActivePolicyOption(store) {
        return store.activePolicyOption;
    },

    getActivePolicy(store) {
        return store.activePolicy;
    },

    getSelectedSequence(store) {
        return store.selectedSequence;
    },

    getInteractionTypes(store) {
        return store.interactionTypes;
    },

    /**
    * Sequences
    */
    getSequences(store) {
        return store.sequences;
    },

    getActiveSequence(store) {
        return store.activeSequence;
    },

    getSequenceCards(store) {
        return store.sequenceCards;
    },

    getOriginalSequenceCards(store) {
        return store.originalSequenceCards;
    },

    getSequenceStatus(store) {
        return store.unsavedSequence;
    },

    /**
     * Error messaging
     */
    getErrors(store) {
        return store.errors;
    }
};



// WEBPACK FOOTER //
// ./src/store/getters.js